import { type AsociacionListItem, type AsociacionRequest, type AsociacionResponse } from '../types/asociacion';
import { http } from '../../../../api/http';

export class AsociacionService {
  private static readonly ENDPOINTS = {
    LIST: '/Asociacion/list',
    CREATE: '/Asociacion',
    GET_BY_ID: '/Asociacion',
  };

  public static async getAsociaciones(): Promise<AsociacionListItem[]> {
    try {
      const response = await http.get(this.ENDPOINTS.LIST);
      return response.data;
    } catch (error) {
      console.error('Error fetching asociaciones:', error);
      throw error;
    }
  }

  public static async saveAsociacion(asociacionRequest: AsociacionRequest): Promise<AsociacionListItem> {
    try {
      const isUpdate = !!asociacionRequest.idAsociacion;

      console.log(`${isUpdate ? 'Updating' : 'Creating'} asociacion:`, {
        url: this.ENDPOINTS.CREATE,
        method: 'POST',
        isUpdate,
        data: asociacionRequest
      });

      const response = await http.post(this.ENDPOINTS.CREATE, asociacionRequest);

      console.log(`Asociacion ${isUpdate ? 'updated' : 'created'} successfully:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error ${asociacionRequest.idAsociacion ? 'updating' : 'creating'} asociacion:`, error);
      throw error;
    }
  }

  public static async createAsociacion(asociacionRequest: AsociacionRequest): Promise<AsociacionListItem> {
    return this.saveAsociacion(asociacionRequest);
  }

  public static async getAsociacionById(idAsociacion: number): Promise<AsociacionResponse> {
    try {
      const response = await http.get(`${this.ENDPOINTS.GET_BY_ID}/${idAsociacion}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching asociacion by id:', error);
      throw error;
    }
  }
}